import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  fetchDestinations,
  createDestination,
  deleteDestination,
  updateDestination,
  removeAerolineDestination,
  removeHotelDestination,
  assignAerolinesDestination,
  assignHotelsDestination,
  assignOperatorsDestination,
  removeOperatorDestination
} from '../../services/destinations'
import { toast } from 'react-toastify';


export const getDestinations = createAsyncThunk(
  'destinations/fetchDestinations',
  async (_, thunkAPI) => {
    try {
      const res = await fetchDestinations()
      if (res.error) throw new Error(res.error.message);
      return res.data
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  },
)

export const addDestination = createAsyncThunk(
  'destinations/addDestination',
  async (data, thunkAPI) => {
    try {

      const res = await toast.promise(
        createDestination(data).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se registró correctamente 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );


      return res.data[0]
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)


export const removeDestination = createAsyncThunk(
  'destinations/removeDestination',
  async (id, thunkAPI) => {
    try {

      await toast.promise(
        deleteDestination(id).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se eliminó correctamente 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );

      return id
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)

export const editDestination = createAsyncThunk(
  'destinations/editDestination',
  async ({ id, ...destination }, thunkAPI) => {
    try {

      const res = await toast.promise(
        updateDestination(id, destination).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se actualizó correctamente 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );
      

      return res.data[0]
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)

export const assignHotelToDestination = createAsyncThunk(
  'destinations/assignHotelToDestination',
  async ({id,items}, thunkAPI) => {
    try {

      const res = await toast.promise(
        assignHotelsDestination(items).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se asignó el hotel 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );


      return {id,items:res.data}
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)

export const assignAerolineToDestination = createAsyncThunk(
  'destinations/assignAerolineToDestination',
  async ({id,items}, thunkAPI) => {
    try {

      
      const res = await toast.promise(
        assignAerolinesDestination(items).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se asignó la aerolínea 😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );

      return {
        id,
        items:res.data
      }
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)

export const removeAerolineFromDestination = createAsyncThunk(
  'destinations/removeAerolineFromDestination',
  async ({destinationId,id}, thunkAPI) => {
    try {

      await toast.promise(
        removeAerolineDestination(id).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se retiró la aerolínea al destino😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );
      return {destinationId,id}
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)

export const assignOperatorToDestination = createAsyncThunk(
  'destinations/assignOperatorToDestination',
  async ({id, items}, thunkAPI) => {
    try {
      const res = await toast.promise(
        assignOperatorsDestination(items).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: { render() { return "Cargando"; }, icon: false },
          success: { render() { return `Se asignó el proveedor de traslado 😏`; }, icon: "🚀" },
          error: { render({ data: errData }) { return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`; } }
        }
      );
      return { id, items: res.data };
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message });
    }
  }
)

export const removeOperatorFromDestination = createAsyncThunk(
  'destinations/removeOperatorFromDestination',
  async ({destinationId, id}, thunkAPI) => {
    try {
      await toast.promise(
        removeOperatorDestination(id).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: { render() { return "Cargando"; }, icon: false },
          success: { render() { return `Se retiró el proveedor de traslado al destino😏`; }, icon: "🚀" },
          error: { render({ data: errData }) { return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`; } }
        }
      );
      return { destinationId, id };
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message });
    }
  }
)

export const removeHotelFromDestination = createAsyncThunk(
  'destinations/removeHotelFromDestination',
  async ({destinationId,id}, thunkAPI) => {
    try {
      

      await toast.promise(
        removeHotelDestination(id).then((response) => {
          if (response.error) throw response.error;
          return response;
        }),
        {
          pending: {
            render() {
              return "Cargando"
            },
            icon: false,
          },
          success: {
            render({ data: responseData }) {
              return `Se retiró el hotel al destino😏`
            },
            icon: "🚀",
          },
          error: {
            render({ data: errData }) {
              return errData?.message ? `Error: ${errData.message}` : `Ocurrió un error`
            }
          }
        }
      );

      return {destinationId,id}
    } catch (err) {
      return thunkAPI.rejectWithValue({ error: err.message })
    }
  }
)

